import script from "./OpsOperationLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsOperationLogs.vue?vue&type=script&setup=true&lang=js"

import "./OpsOperationLogs.vue?vue&type=style&index=0&id=bcf40dcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcf40dcc"]])

export default __exports__